import { ApiCall } from '../ApiClient';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export type SurveyOption = {
    id: string,
    label: string,
};

export type SurveyQuestion = {
    id: string,
    label: string,
    subLabel?: string,
    type: 'single' | 'multi',
    options: SurveyOption[],
};

export type SurveyAnswer = {
    id: string,
    questionId: string,
    type: 'single' | 'multi',
    label: string,
};

export type SurveyDefintion = {
    id: string,
    name: string,
    label: string,
    questions: SurveyQuestion[],
};

export type Survey = {
    id: string,
    definitionId: string,
    answers: SurveyAnswer[],
};

export const surveysExports = {

    create: (body: Survey) => post<string>({
        path: '/surveys.create',
        body,
    }),

    info: (name: string) => get<SurveyDefintion>({
        path: '/surveys.info',
        query: { name },
    }),
};
